import React from 'react';

const HorariosHeader = ({
  sucursales,
  horarios,
  sucursalSeleccionada,
  horarioSeleccionado,
  onSucursalChange,
  onHorarioChange,
  onCrearClick,
  loading,
  tieneSucursales
}) => {
  const selectStyle = {
    border: '2px solid rgba(59, 130, 246, 0.3)',
    borderRadius: '8px',
    padding: '0.75rem',
    fontSize: '1rem',
    backgroundColor: '#fafafa',
    cursor: 'pointer',
    transition: 'all 0.2s'
  };

  const buttonStyle = {
    backgroundColor: '#3b82f6',
    color: 'white',
    border: 'none',
    padding: '0.75rem 1.25rem',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '1rem',
    fontWeight: '600',
    transition: 'all 0.2s',
    marginLeft: '0.75rem'
  };

  return (
    <div style={{
      display: 'flex',
      gap: '1rem',
      marginBottom: '2rem',
      alignItems: 'center',
      flexWrap: 'wrap'
    }}>
      {tieneSucursales && (
        <>
          <label style={{ fontWeight: '600', color: '#374151' }}>
            Sucursal:
          </label>
          <select
            value={sucursalSeleccionada || ''}
            onChange={(e) => onSucursalChange(Number(e.target.value))}
            style={{ ...selectStyle, minWidth: '200px' }}
            disabled={loading}
          >
            <option value="">-- Selecciona una sucursal --</option>
            {sucursales.map(s => (
              <option key={s.id} value={s.id}>
                {s.nombre}
              </option>
            ))}
          </select>
        </>
      )}

      <label style={{ fontWeight: '600', color: '#374151' }}>
        Horario:
      </label>
      <select
        value={horarioSeleccionado || ''}
        onChange={(e) => onHorarioChange(Number(e.target.value))}
        style={{ ...selectStyle, minWidth: '200px' }}
        disabled={loading || horarios.length === 0}
      >
        <option value="">-- Selecciona un horario --</option>
        {horarios.map(h => (
          <option key={h.id} value={h.id}>
            {h.nombre}
          </option>
        ))}
      </select>

      <button
        onClick={onCrearClick}
        style={buttonStyle}
        onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
        onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
      >
        + Nuevo Horario
      </button>
    </div>
  );
};

export default HorariosHeader;
